import { Button, CircularProgress } from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";

const PaginationComponent = ({
  query,
  setQuery,
}: {
  query: any;
  setQuery: any;
}) => {
  const page = useMemo(() => {
    return query?.page ? Number(query?.page) : 1;
  }, [query]);

  const [paginateLoading, setPaginateLoading] = useState(false);
  const [inputPage, setInputPage] = useState("");

  const goToPage = useCallback(
    (pageNumber: number) => {
      setPaginateLoading(true);
      setQuery({
        ...query,
        page: pageNumber,
      });
      const currentParams = new URLSearchParams(window.location.search);
      currentParams.set("page", String(pageNumber));
      // router.push(`${url}?${currentParams.toString()}`);
    },
    [query, setQuery]
  );

  const generatePageNumbers = () => {
    const totalPages = query?.totalPage || query?.totalPages;
    if (!totalPages || totalPages <= 1) return [];

    const pages = [];
    if (page > 3) pages.push(1, "...");

    for (
      let i = Math.max(1, page - 1);
      i <= Math.min(totalPages, page + 1);
      i++
    ) {
      pages.push(i);
    }

    if (page < totalPages - 2) pages.push("...", totalPages);

    return pages;
  };

  // useEffect(() => {
  //   if (paginateLoading) {
  //     setPaginateLoading(false);
  //   }
  // }, [data]);

  return (
    <div className="flex items-center mt-5 mb-5 justify-end">
      <Button
        onClick={() => goToPage(1)}
        disabled={page === 1 || paginateLoading}
      >
        {"First"}
      </Button>
      <Button
        onClick={() => goToPage(page - 1)}
        disabled={page === 1 || paginateLoading}
      >
        {"Prev"}
      </Button>
      <div className="flex space-x-2">
        {generatePageNumbers().map((num, idx) =>
          num === "..." ? (
            <span key={idx} className="px-2">
              {num}
            </span>
          ) : (
            <Button
              style={{
                color: num === page ? "white" : "",
                background: num === page ? "#E77228" : "",
              }}
              disabled={paginateLoading}
              key={idx}
              onClick={() => goToPage(num)}
            >
              {num}
            </Button>
          )
        )}
      </div>
      <Button
        onClick={() => goToPage(page + 1)}
        disabled={
          page === (query?.totalPage || query?.totalPages) || paginateLoading
        }
      >
        {"Next"}
      </Button>
      <Button
        onClick={() => goToPage(query?.totalPage || query?.totalPages)}
        disabled={
          page === (query?.totalPage || query?.totalPages) || paginateLoading
        }
      >
        {"Last"}
      </Button>
      <div className="border border-1 h-[40px] text-gray-400 text-sm rounded-md flex items-center">
        {"Go to page"}:
      </div>
      <input
        type="number"
        className="w-16 border outline-none text-center border-1 h-[40px] rounded-md"
        value={inputPage}
        onChange={(e: any) => setInputPage(e.target.value)}
        onKeyPress={(e: any) => {
          if (e.key === "Enter") {
            const num = parseInt(inputPage, 10);
            if (
              num >= 1 &&
              num <= (query?.totalPage || query?.totalPages) &&
              num !== page
            )
              goToPage(num);
          }
        }}
        placeholder=""
      />
      <Button
        onClick={() => {
          const num = parseInt(inputPage, 10);
          if (
            num >= 1 &&
            num <= (query?.totalPage || query?.totalPages) &&
            num !== page
          )
            goToPage(num);
        }}
        disabled={
          page === (query?.totalPage || query?.totalPages) || paginateLoading
        }
      >
        {"Go"}
      </Button>

      {paginateLoading ? <CircularProgress size={20} /> : null}
    </div>
  );
};

export default PaginationComponent;
